import { useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Note } from "../../../service/model/note.model";
import { Box, Button, Dialog, DialogTitle, Grid } from "@mui/material";
import FormField from "../../../components/form-controls/form-field";
import theme from "../../../app/app-theme";
import { NoteTargetType } from "../../../shared/enums";
import FormCloseButton from "../../../components/form-controls/form-close-button";
import { FormTextField } from "../../../components/form-input-field-wrappers/form-controller-inputs/form-text-field";

interface NoteFormProps {
    readonly note?: Note
    readonly targetType: NoteTargetType
    readonly targetId: number
    readonly editable: boolean
    readonly onClose: () => void
    readonly onSubmit: (data: Note) => void
}

const style = {
    // position: 'absolute' as 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    // width: 400,
    // bgcolor: 'background.paper',
    // border: '2px solid #000',
    // boxShadow: 24,
    p: 2,
};

const NoteForm: React.FC<NoteFormProps> = ({ note, targetType, targetId, onClose, onSubmit }) => {
    const schema = yup.object().shape({
        content: yup.string()
            .required("Content is required"),
        dueDate: yup.string(),
    });

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmitHandler = (data: any) => {
        onSubmit({...note, content: data.content, dueDate: data.dueDate, targetId: targetId, targetType: targetType} as Note)
    };

    return (
        <Dialog open={true} onClose={onClose} sx={style} fullWidth maxWidth='sm'>
            <DialogTitle>Note Details</DialogTitle>
            <Box sx={style}>
                <>
                    <FormCloseButton onClose={onClose} />
                    <form onSubmit={handleSubmit(onSubmitHandler)}>
                        <FormField>
                            <FormTextField
                                id="content"
                                label="Content"
                                name="content"
                                defaultValue={note?.content}
                                errorMessage={errors.content?.message}
                                register={register}
                            />
                        </FormField>
                        <FormField>
                            <FormTextField
                                id="dueDate"
                                label="Due Date"
                                type="date"
                                name="dueDate"
                                defaultValue={note?.dueDate}
                                errorMessage={errors.dueDate?.message}
                                register={register}
                            />
                        </FormField>
                        <Grid container direction="row" justifyContent='end' sx={{ mt: 1 }}>
                            <Button type="button" variant="contained" sx={{ mr: 1, bgcolor: `${theme.palette.secondary.main}` }} onClick={onClose}>Cancel</Button>
                            <Button type="submit" variant="contained" >Submit</Button>
                        </Grid>
                    </form>
                </>
            </Box>
        </Dialog>
    );
}

export default NoteForm;